// convex/lib/config/core.ts
// Core configuration - no imports from helpers.ts to avoid circular dependencies

import { systemDomain } from "./domains/system";
import { securityDomain } from "./domains/security";
import { clientsDomain } from "./domains/clients";
import { reportsDomain } from "./domains/reports";
import { subscriptionsDomain } from "./domains/subscriptions";
import { notificationsDomain } from "./domains/notifications";
import { uiDomain } from "./domains/ui";
import { documentsDomain } from "./domains/documents";
import { logisticsDomain } from "./domains/logistics";

export const allDomains = [
  systemDomain,
  securityDomain,
  clientsDomain,
  reportsDomain,
  subscriptionsDomain,
  notificationsDomain,
  uiDomain,
  documentsDomain,
  logisticsDomain,
];

export const ERP_MODULES_CONFIG = {
  modules: Object.fromEntries(allDomains.map((d) => [d.id, d])),
  metadata: {
    version: "3.0.0",
    lastUpdated: "2026-04-04",
    description: "Configuracion unificada por dominio",
  },
};

export const tableConfigs = Object.fromEntries(
  allDomains
    .flatMap((d) => d.modules)
    .flatMap((m) => m.tables)
    .map((t) => [t.tableName, t]),
);
